import { render, staticRenderFns } from "./ItemRecycle.vue?vue&type=template&id=6ed6de3b&scoped=true"
import script from "./ItemRecycle.vue?vue&type=script&lang=ts"
export * from "./ItemRecycle.vue?vue&type=script&lang=ts"
import style0 from "./ItemRecycle.vue?vue&type=style&index=0&id=6ed6de3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed6de3b",
  null
  
)

export default component.exports